import { useEffect, useState } from "react";
import Analytics from "../../../utils/analytics";

export type ConfirmEmployerType = ReturnType<typeof ConfirmEmployerController>;

export type EmployerOptionsProps = {
  goToAccountCreationScreen(isCurrentEmployer: boolean): () => () => any;
  showMailingListScreen(): any;
  employerName: string;
};

export enum EmploymentStatus {
  currentlyWorks = "CURRENTLY_WORKS",
  previouslyWorked = "PREVIOUSLY_WORKED",
  neverWorked = "NEVER_WORKED",
}

const ConfirmEmployerController = (props: EmployerOptionsProps) => {
  const { goToAccountCreationScreen, showMailingListScreen } = props;
  const [showPopup, setShowPopup] = useState(false);
  const [employmentStatus, setEmploymentStatus] = useState<string | null>(null);

  const handleClick = (status: EmploymentStatus) => () => setEmploymentStatus(status);

  const handleContinue = () => {
    switch (employmentStatus) {
      case EmploymentStatus.currentlyWorks:
        return goToAccountCreationScreen(true)();
      case EmploymentStatus.previouslyWorked:
        return goToAccountCreationScreen(false)();
      case EmploymentStatus.neverWorked:
        return showMailingListScreen();
      default:
      // do nothing
    }
  };

  const handlePopup = () => {
    setShowPopup(!showPopup);
  };

  useEffect(() => {
    Analytics.setProperties({
      entity: "page",
      properties: {
        pageName: "EmploymentStatusScreen",
      },
    });
  }, []);

  return {
    ...props,
    handlePopup,
    handleClick,
    handleContinue,
    showPopup,
    employmentStatus,
    setEmploymentStatus,
  };
};

export default ConfirmEmployerController;
